import { binaryModalAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-modal-actions/binary-modal-action';
import { documentReferenceModalAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-modal-actions/document-reference-modal-action';
import type { UseResourceModalOpenModalArgs } from '@ctw/shared/context/resource-modal-context';
import type {
  FetchableModelType,
  FetchableResourceType,
} from '@ctw/shared/utils/fhir/resource-mappings';

const resourceTypeModalActionMap: {
  [TResourceType in FetchableResourceType]: TResourceType extends Extract<
    FetchableResourceType,
    'Binary' | 'DocumentReference'
  >
    ? UseResourceModalOpenModalArgs<TResourceType>['action']
    : undefined;
} = {
  Condition: undefined,
  MeasureReport: undefined,
  EpisodeOfCare: undefined,
  Encounter: undefined,
  MedicationStatement: undefined,
  DiagnosticReport: undefined,
  Observation: undefined,
  AllergyIntolerance: undefined,
  Immunization: undefined,
  ServiceRequest: undefined,
  Measure: undefined,
  Practitioner: undefined,
  DocumentReference: documentReferenceModalAction,
  Binary: binaryModalAction,
} as const;

export const resourceModalActionForModel = <
  TResourceType extends FetchableResourceType = FetchableResourceType,
  TModel extends FetchableModelType<TResourceType> = FetchableModelType<TResourceType>,
>(
  model: TModel,
) => resourceTypeModalActionMap[model.resourceType as keyof typeof resourceTypeModalActionMap];
